// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1c96I","buttonFake":"styles_buttonFake__1g3va","invisibleText":"styles_invisibleText__Ra0Ml"};